<template>
  <loading-screen v-show="isVisible" :content="loadingScreenContent" />
</template>

<script>
import LoadingScreen from '../components/LoadingScreen.vue';
export default {
  name: 'ApplicationsNew',

  components: {
    LoadingScreen,
  },

  data() {
    return {
      loadingScreenContent: {
        title: {
          text: 'Creating a New Program Application',
          class: ['egx-partner-color'],
          style: 'color: var(--egx-partner-color)',
        },
        description: {
          text: 'Please wait while we create an application for the program you selected',
          class: [],
          style: {},
        },
        spinner: {
          class: ['egx-partner-color'],
          style: {},
        },
        cta: {
          text: 'If this page doesn\'t refresh, please click here',
          class: ['egx-partner-color'],
          style: {},
          path_name: 'applicationsShowAll',
        },
      },
      isVisible: false,
      applications: [],
    };
  },

  mounted() {
    if (this.fulfill_sync_details.allow_update_created_projects) {
      this.isVisible = true;
      const isContinue = localStorage.getItem('isContinue');

      this.$store.dispatch('fulfill_integrate/getProjects').then(() => {
        this.applications = this.$store.state.fulfill_integrate.projects;
        this.applications = this.applications?.filter((application) => application.site_id == this.currentBuilding.partner_building_id);
        if (isContinue || !this.applications || this.applications.length === 0) {
          if (this.currentBuilding.selectedId) {
            localStorage.removeItem('isContinue');
          }
          this.beginCreateProject()
        } else {
          localStorage.setItem('projectCreation', true);
          this.$router.push({ name: 'AppliedProjects', query: { programId: this.$route.query.programId } });
        }
      }).catch((error) => {
        console.log(error.message);
        this.$notify({
          group: 'notice',
          text: error.message,
        });
      });
    } else {
      this.beginCreateProject();
    }

  },

  computed: {
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    currentBuilding() {
      return this.$store.state.buildings.currentBuilding;
    },
    settings() {
      return this.$store.state.partners.currentPartner.settings;
    },
    fulfill_sync_details() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details;
    },
  },

  methods: {
    beginCreateProject() {
      this.isVisible = true;
      console.log('beginCreateProject');
      this.$store.dispatch('fulfill_integrate/listOrSelectBuilding')
        .then((response) => {
          if(response.building_id || this.currentBuilding.selectedId) {
            const buildingId = response.building_id || this.currentBuilding.selectedId;
            const programId = this.$route.query.programId;
            const params = {
              building_id: buildingId,
              program_id: programId,
            };
            this.$store.dispatch('fulfill_integrate/createProjects', params)
              .then((response) => {
                if(this.$store.state.users.currentUser.extra_info.programId) {
                  this.$store.dispatch('users/get').then(() => {
                    this.$store.dispatch('buildings/getAll').then(() => {
                      console.log("User and Building fetched");
                    });
                  });
                }
                this.isVisible = false;

                if (response?.project_id) {
                  this.$router.push({ path: `/applications/${response.project_id}/edit` });
                } else {
                  this.$notify({
                    group: 'notice-stay',
                    type: 'error',
                    text: this.settings.fulfill_sync_details.messages.initial_project_creation_error || 'An error occurred while creating your project. Please contact support or your system administrator.',
                  });

                  this.$router.push({ name: 'Offers' });
                }
              })
              .catch((error) => {
                console.log(error);
                this.isVisible = false;
                this.$router.push({ name: 'applicationsShowAll', query: { errorPersist: true } });
                this.$notify({
                  group: 'notice-stay',
                  type: 'error',
                  text: error.error,
                });
              });
          } else {
            this.isVisible = false;
            this.$router.push({ path: `/buildings`, query: { programId: this.$route.query.programId } });
          }
        })
        .catch((error) => {
          console.log(error);
          this.isVisible = false;
          this.$router.push({ name: 'applicationsShowAll', query: { errorPersist: true } });
          this.$notify({
            group: 'notice-stay',
            type: 'error',
            text: error.error,
          });
        });
    }
  }
};
</script>
